import Header from "../../Global/Header/Header";
import Footer from "../../Global/Footer/Footer";
import classes from "./SingleTripPage.module.css";
import CuratorCard from "./CuratorCard/CuratorCard";
import SpotForm from "./SpotForm/SpotForm";
import { useRef } from "react";
import { Tabs } from "./Tabs/Tabs";
import { Toaster } from "../../components/ui/toaster";

export const SingleTripView = ({
  showLoader,
  tripName,
  tripTitle,
  tripDetailBgImg,
  curatorViewModel,
  spotFormViewModel,
  quickDetailsViewModel,
  itineraryViewModel,
  onFormSubmitted,
  initiatePayment,
}) => {
  const formRef = useRef(null);

  const scrollHandler = () => {
    formRef.current.scrollIntoView({ behavior: "smooth" });
  };

  if (showLoader) {
    return (
      <>
        <div className="flex flex-col items-center justify-center h-screen bg-gray-100 dark:bg-gray-900">
          <div
            className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
            role="status"
          ></div>
          <p className="mt-4 text-lg font-semibold text-gray-700 dark:text-gray-300">
            Loading ...
          </p>
        </div>
      </>
    );
  }

  return (
    <>
      <div>
        <Header activeTab={""} />
        <div className={classes["entry-component"]}>
          <img
            className={classes["entry-img"]}
            src={tripDetailBgImg}
            alt="Trip Background"
          />
          <div className={classes["curator-card-container"]}>
            <CuratorCard curatorViewModel={curatorViewModel} />
          </div>
          <div className={classes["entry-container"]}>
            <p className={classes["entry-trip-name"]}>
            {tripName}
            </p>
            <p className={classes["entry-trip-title"]}>{tripTitle}</p>
            <button onClick={scrollHandler} className={classes["entry-button"]}>
              Apply now
            </button>
          </div>
        </div>

        <Tabs
          itineraryViewModel={itineraryViewModel}
          quickDetailsViewModel={quickDetailsViewModel}
        />

        <SpotForm spotFormViewModel={spotFormViewModel} formRef={formRef} onFormSubmitted={onFormSubmitted} initiatePayment={initiatePayment} />

        <Footer />
        <Toaster />
      </div>
    </>
  );
};
